import React from "react";
import "./css/About.css";

export default function About() {
  return (
    <div className="container">
      <h1 className="About-header">ABOUT</h1>
      <h2 className="About-intro">Hi, I'm Ranil</h2>
      <div className="About-me">
        <p>
          I am a Computer Science and Engineering graduate from the National
          Institute of Technology, Warangal, with strong expertise in backend
          development, machine learning, and data-driven solutions. Currently, I
          work as an SDE-1 at Innovaccer, where I focus on building scalable
          systems, designing reliable APIs, optimizing workflows, and delivering
          impactful software products that improve efficiency and user
          experience across healthcare platforms.
        </p>
        <p>
          Over time, I have gained significant experience in backend
          engineering, data management, and applied machine learning. My work
          includes architecting efficient database solutions, building
          large-scale services, and experimenting with computer vision and
          predictive models to solve real-world problems. I particularly enjoy
          the challenge of turning complex requirements into elegant technical
          solutions that are maintainable, high-performing, and aligned with
          business needs. These experiences have sharpened my ability to design
          and implement systems that balance scalability with simplicity.
        </p>
        <p>
          As a continuous learner, I am deeply committed to expanding my
          technical expertise and staying ahead in the rapidly evolving tech
          landscape. I am especially passionate about applying backend
          engineering and machine learning to create meaningful impact, whether
          it’s enhancing user experiences, streamlining operations, or enabling
          smarter decision-making. My goal is to keep pushing boundaries through
          innovation, collaboration, and technical excellence while working on
          projects that truly make a difference.
        </p>
      </div>
      {/*<button className="Resume">
          <a
            href="https://drive.google.com/file/d/1oE5_QHJRV7htyej_V2gpVnQ2uxuEBlBE/view?usp=sharing"
            target="_blank"
            rel="noopener noreferrer"
          >
            Resume
          </a>
        </button>*/}
    </div>
  );
}
